import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/setDefaultOnJobBulk`;

export const ROUTE: RouteDefinition = `${baseRoute}/setDefaultOnJobBulk`;

export const URL = (): RouteDefinition => `${baseRoute}/setDefaultOnJobBulk`;
